export default [
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Deal amount (from-to)',
    },
    cell: {
      type: 'slot',
      name: 'dealAmount',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Trader profit',
    },
    cell: {
      type: 'slot',
      name: 'traderProfit',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: 'Merchant fees',
    },
    cell: {
      type: 'slot',
      name: 'merchantFee',
    },
  },
  {
    width: 17,
    header: {
      type: 'slot',
      name: 'systemProfitHeader',
    },
    cell: {
      type: 'slot',
      name: 'systemProfit',
    },
  },
  {
    width: 17,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
